import { DTO } from './supplierDTOS.models';

export namespace SupplierOrders {
  export interface IOrder {
    supplier_certificate_id: number;
    supplier_id: number;
    order_date: string;
    order_number: string;
    delivery_date: string;
    closing_date: string | null;
    product_count: number;
    perc_progress?: number;
    is_partial?: boolean;
    article_count?: number;
  }

  export class Order implements IOrder {
    supplier_certificate_id = 0;
    supplier_id = 0;
    order_date = '';
    order_number = '';
    delivery_date = '';
    closing_date: string | null = null;
    product_count = 0;
    perc_progress?: number = 0;
    is_partial?: boolean = false;
    article_count?: number = 0;

    constructor(order?: Partial<IOrder>) {
      Object.assign(this, order);
    }
  }

  export class OrdersResponse {
    success = false;
    error_message: string | null = null;
    data: { supplier_certificates: Order[] } = { supplier_certificates: [] };

    constructor(response?: Partial<DTO.OrdersResponseDto>) {
      this.success = response?.success ?? false;
      this.error_message = response?.error_message ?? null;
      this.data = {
        supplier_certificates:
          response?.data?.supplier_certificates?.map((x) => new Order(x)) ?? [],
      };
    }
  }
  export class OrdersResponsePartial {
    success = false;
    error_message: string | null = null;
    data: { partial_orders: Order[] } = { partial_orders: [] };

    constructor(response?: Partial<DTO.OrderPartialResponse>) {
      this.success = response?.success ?? false;
      this.error_message = response?.error_message ?? null;
      this.data = {
        partial_orders:
          response?.data?.partial_orders?.map((x) => new Order(x)) ?? [],
      };
    }
  }
  export interface IAddNewOrderFromGamma {
    supplier_id: number;
    supplier_code: number;
    order_number: string;
  }

  export interface ISupplier {
    account_id: number;
    ac_email: string;
    ac_nome: string;
    ac_cognome: string;
    ac_attivo: boolean;
    supplier: {
      supplier_id: number;
      code: string;
      name: string;
      email: string;
    };
  }
  export class Supplier implements ISupplier {
    account_id = 0;
    ac_email = '';
    ac_nome = '';
    ac_cognome = '';
    ac_attivo = false;
    supplier = {
      supplier_id: 0,
      code: '',
      name: '',
      email: '',
    };

    constructor(supplier?: Partial<ISupplier>) {
      if (!supplier) return;
      Object.assign(this, supplier);
    }
  }

  export interface IResponseOrderFromGamma {
    supplier_certificate_id: number;
    supplier_id: number;
    order_date: string;
    order_number: string;
  }

  export class ResponseOrderFromGamma implements IResponseOrderFromGamma {
    supplier_certificate_id = 0;
    supplier_id = 0;
    order_date = '';
    order_number = '';

    constructor(response?: Partial<IResponseOrderFromGamma>) {
      if (!response) return;
      Object.assign(this, response);
    }
  }
}
